import { Component, OnInit } from '@angular/core';
import { PermissionService } from '@abp/ng.core';
import { FeatureService } from 'src/core/services/feature/feature.service';
import { FeatureConstants } from 'src/core/constants/feature-constant';
import { SettingsDefinitionModel } from 'src/core/models/shared/settings-definition.model';
import { PermissionConstants } from 'src/core/constants/permission-constant';

@Component({
  selector: 'ca-generative-ai-setting-group',
  templateUrl: './generative-ai-setting-group.component.html',
  styleUrls: ['./generative-ai-setting-group.component.scss'],
  standalone: false,
})
export class GenerativeAiSettingGroupComponent implements OnInit {
  activeTab: number = 1;

  analyticsFeatureEnabled: boolean = false;
  summarizationFeatureEnabled: boolean = false;
  askGenAIFeatureEnabled: boolean = false;

  canManageTranslation: boolean = false;
  canManageSettings: boolean = false;
  canManageRootCause: boolean = false;

  settingsDefinitionItems: SettingsDefinitionModel[] = [
    {
      label: '::RootCauses',
      navigationData: ['administration', 'root-cause'],
      extraData: null,
      requiredPolicies: [PermissionConstants.RootCause],
      forFeatures: [FeatureConstants.AskGenAi],
    },
  ];

  constructor(
    private permissionService: PermissionService,
    private featureService: FeatureService
  ) {
    this.analyticsFeatureEnabled = this.featureService.isEnabled(FeatureConstants.Analytics);
    this.summarizationFeatureEnabled = this.featureService.isEnabled(
      FeatureConstants.ConversationSummarization
    );
    this.askGenAIFeatureEnabled = this.featureService.isEnabled(FeatureConstants.AskGenAi);
    this.canManageSettings = this.permissionService.getGrantedPolicy(
      PermissionConstants.SettingManagement
    );
    this.canManageTranslation = this.permissionService.getGrantedPolicy(
      PermissionConstants.Translation
    );
    this.canManageRootCause = this.permissionService.getGrantedPolicy(
      PermissionConstants.RootCause
    );
  }

  ngOnInit(): void {
    if (this.analyticsFeatureEnabled && this.canManageSettings) {
      this.activeTab = 1;
    } else {
      this.activeTab = 6;
    }
  }
}
